export default {
  'pages.propertyOverview.title': 'Property Overview',
  'pages.propertyOverview.subTitle':
    'Centralized view of overall property operations and key summary information.',
  'pages.propertyOverview.monthlyStats.title': 'Monthly Billing Statistics',
  'pages.propertyOverview.monthlyStats.paidAmount': 'Total Collected This Month',
  'pages.propertyOverview.monthlyStats.unpaidAmount': 'Total Outstanding Amount',
  'pages.propertyOverview.monthlyStats.unpaidCount': 'Outstanding Bill Count',
  'pages.propertyOverview.quickFunction.title': 'Quick Functions',
  'pages.propertyOverview.feeCenter.title': 'Billing Center',
  'pages.propertyOverview.commonFunction.title': 'Common Functions',
  'pages.propertyOverview.fee.property': 'Property Fee',
  'pages.propertyOverview.fee.electric': 'Electricity Fee',
  'pages.propertyOverview.fee.water': 'Water Fee',
  'pages.propertyOverview.fee.network': 'Internet/Broadband Fee',
  'pages.propertyOverview.fee.parking': 'Parking Fee',
  'pages.propertyOverview.fee.other': 'Other Misc Fees',
  'pages.propertyOverview.fee.unit.pendingPayment': 'Pending Bills',
  'pages.propertyOverview.fee.unit.lowBalanceWarning': 'Low Balance Alerts',
  'pages.propertyOverview.fee.unit.abnormalFlow': 'Abnormal Flow',
  'pages.propertyOverview.fee.unit.expiringSoon': 'Expiring Soon',
  'pages.propertyOverview.fee.unit.renewalPending': 'Pending Renewals',
  'pages.propertyOverview.quickLink.importantNotice': 'Important Notices',
  'pages.propertyOverview.quickLink.paymentNotice': 'Payment Notice',
  'pages.propertyOverview.quickLink.utilityOpen': 'Utility Setup',
  'pages.propertyOverview.quickLink.venueBooking': 'Venue Booking',
  'pages.propertyOverview.quickLink.vehicleBinding': 'Vehicle Binding',
  'pages.propertyOverview.quickLink.dailyReport': 'Daily Report',
  'pages.propertyOverview.auditWorkbench.title': 'Pending Approval Workbench',
  'pages.propertyOverview.action.handle': 'Handle',
  'pages.propertyOverview.audit.repair': 'Maintenance Management',
  'pages.propertyOverview.audit.complaint': 'Complaint Management',
  'pages.propertyOverview.audit.guest': 'Guest Registration',
  'pages.propertyOverview.audit.decoration': 'Decoration Filing',
  'pages.propertyOverview.audit.moveout': 'Move-out Registration',
  'pages.propertyOverview.audit.status.processing': 'in progress',
  'pages.propertyOverview.audit.status.pending': 'pending records',
};
